<template>
  <v-card flat>
    <v-card-title>
      <v-btn-toggle v-model="documentType" mandatory>
          <v-btn value="01">
            <span class="hidden-sm-and-down">Factura</span><span class="hidden-md-and-up">F</span>
          </v-btn>
          <v-btn value="02">
            <span class="hidden-sm-and-down">Nota de Crédito</span><span class="hidden-md-and-up">NC</span>
          </v-btn>
          <v-btn value="03">
            <span class="hidden-sm-and-down">Nota de Débito</span><span class="hidden-md-and-up">ND</span>
          </v-btn>
          <v-btn value="04">
            <span class="hidden-sm-and-down">Guías de Despacho</span><span class="hidden-md-and-up">G</span>
          </v-btn>
        <v-btn value="05">
          <span class="hidden-sm-and-down">Comprobantes de Retención IVA</span><span class="hidden-md-and-up">CR-IVA</span>
        </v-btn>
        <v-btn value="06">
            <span class="hidden-sm-and-down">Comprobantes de Retención ISLR</span><span class="hidden-md-and-up">CR-ISLR</span>
          </v-btn>
      </v-btn-toggle>
    </v-card-title>
        <v-btn
          :color="themeColor"
          dark
          @click="openModalAyuda()"
          block
        >
          ¿Ayuda para filtrar? Click Aquí
        </v-btn>
    <v-card-text>
      <v-row>
        <v-col cols="2">
          <v-img :aspect-ratio="4/3"
            max-height="420" contain :lazy-src="url" :src="logo" />
        </v-col>
        <v-col cols="10" style="margin-top:20px;">
          <v-select
              v-model="cat_province_id"
              :items="itemsProvince"
              item-value="code"
              item-text="name"
              label="Estado"
              @onchage="getProvincia()"
            />
          <vuetify-select :client_type="client_type" :states="cat_province_id" />
              <v-select
                v-model="client_type"
                :items="clientStatus"
                label="Tipo de cliente"
                style="margin-top:20px;"
              />
        </v-col>
      </v-row>
      <template>
        <v-row>
          <v-col cols="12">
            <vuetify-table
              :headers="headers"
              :api-u-r-l="apiURL"
              :readonly="true"
              :title="currentTitle"
              :query-params="queryParams"
              :isDocuments="true"
              :refresh="refresh"
              :islazySearch="true"
            >
              <template v-slot:filters>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="3">
                    <v-menu
                      v-model="dateMenu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="computedDateFormattedStart"
                          label="Fecha desde"
                          readonly
                          single-line
                          hide-details
                          v-on="on"
                        />
                      </template>
                      <v-col cols="12" style="padding: 0 !important;">
                        <v-date-picker
                          :color="themeColor"
                          :max="dateMax"
                          v-model="dateStart"
                          @input="dateMenu1 = false"
                        />
                      </v-col>
                      <v-col cols="12" sm="12" style="padding: 0 !important;">
                        <v-btn
                          block
                          :color="themeColor"
                          dark
                          @click="today('one')"
                        >
                          HOY
                        </v-btn>
                      </v-col>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-menu
                      v-model="dateMenu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="computedDateFormattedEnd"
                          label="Fecha hasta"
                          readonly
                          single-line
                          hide-details
                          v-on="on"
                        />
                      </template>
                      <v-col cols="12" style="padding: 0 !important;">
                        <v-date-picker
                          :color="themeColor"
                          v-model="dateEnd"
                          :max="dateMax"
                          @input="dateMenu2 = false"
                        />
                      </v-col>
                      <v-col cols="12" style="padding: 0 !important;">
                        <v-btn
                          block
                          :color="themeColor"
                          dark
                          @click="today('two')"
                        >
                          HOY
                        </v-btn>
                      </v-col>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="search"
                      label="Buscar"
                      single-line
                      hide-details
                    />
                  </v-col>
                </v-row>
              </template>
              <template v-slot:actions-filters>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="themeColor"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      @click="updateQueryParams"
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                  <span>Realizar busqueda</span>
                </v-tooltip>
              </template>
            </vuetify-table>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
    <v-dialog
      v-model="dialogAyuda"
      max-width="700"
    >
      <v-card>
        <v-card-title class="headline">
          ¿Necesitas ayuda para realizar un filtro?
        </v-card-title>
        <v-card-text>
          Puede filtrar su información por un campo específico al escribir cualquiera de las siguientes etiquetas separadas por punto y coma ;
        </v-card-text>
        <v-card-text>
          ADQUIRIENTE: J-123456789 (Nº Identificación Adquiriente).
        </v-card-text>
        <v-card-text>
          TERCERO: V-12345678 (PROPIOS Para incluir solo propios).
        </v-card-text>
        <v-card-text>
          SERIE: A (Serie del Documento).
        </v-card-text>
        <v-card-text>
          NUM: 00000000 (N° de Documento).
        </v-card-text>
        <v-card-text>
          CONTROL: 00-00000000 (N° de Control).
        </v-card-text>
        <v-card-text>
          ESTADO: ENVIADA ó ANULADA.
        </v-card-text>
        <v-card-text>
          TRANSACCION: 000000000 (N° DE LA TRANSACCIÓN).
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="dialogAyuda = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { format, parseISO } from 'date-fns';
import VuetifyTable from '~/components/VuetifyTable';
import VuetifySelect from '~/components/VuetifySelect';

const headersAll = [
      {
        text: 'Emisor',
        value: 'emisor_number_id',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Adquiriente',
        value: 'receiver_number_id',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Terceros',
        value: 'external_number_id',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Serie',
        value: 'serie',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Transacción',
        value: 'transaction_id',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Nº Documento',
        value: 'document_number',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Nº Control',
        value: 'control_number',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Fecha Emisión',
        value: 'issue_date',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Fecha Recepción',
        value: 'reception_date',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Estado',
        value: 'status',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Acciones',
        value: 'action_documents',
        sortable: false,
      },
    ];

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('documents') };
  },
  components: {
    VuetifyTable,
    VuetifySelect,
  },
  data: () => ({
    headers: [],
    titles: {
      '01': 'Factura',
      '02': 'Nota de Crédito',
      '03': 'Nota de Débito',
      '04': 'Guías de Despacho',
      '05': 'Comprobantes de Retención IVA',
      '06': 'Comprobantes de Retención ISLR',
    },
    clientStatus: [
      { value: '0', text: 'No asignado' },
      { value: '1', text: 'Optativo' },
      { value: '2', text: 'Obligatorio' },
      { value: '3', text: 'Hibrido' },
    ],
    cat_province_id: '',
    client_type: '',
    itemsProvince: [],
    items: [],
    totalItems: 0,
    apiURLBase: 'api/documents',
    documentType: '01',
    dateStart: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
    dateEnd: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
    dateMax: format(parseISO(new Date(new Date().setDate(new Date().getDate() + 3)).toISOString()), 'yyyy-MM-dd'),
    dateMenu1: false,
    dateMenu2: false,
    dialogAyuda: false,
    isReadonly: false,
    queryParams: `&type=01&dateStart=${format(parseISO(new Date().toISOString()), 'yyyy-MM-dd')}
      &dateEnd=${format(parseISO(new Date().toISOString()), 'yyyy-MM-dd')}&search=`,
    search: '',
    url: 'https://cdn.vuetifyjs.com/images/parallax/material.jpg',
    logo: 'https://cdn.vuetifyjs.com/images/parallax/material.jpg',
    refresh: true,
  }),
  computed: {
    apiURL() {
      return `${this.apiURLBase}`;
    },
    currentTitle() {
      return this.titles[this.documentType];
    },
    ...mapGetters({
      user: 'auth/user',
      taxpayer_id: 'taxpayer/id',
      taxpayer_rif: 'taxpayer/rif',
      themeColor: 'theme/themeColor',
    }),
    computedDateFormattedStart() {
      return this.dateStart ? moment(this.dateStart).format('DD-MM-YYYY') : '';
    },
    computedDateFormattedEnd() {
      return this.dateEnd ? format(parseISO(this.dateEnd), 'dd-MM-yyyy') : '';
    },
    vamoaver() {
      return (!this.isReadonly || this.client_type === '');
    },
  },
  watch: {
    documentType: {
      handler(newDocumentType) {
        this.queryParams = `&type=${newDocumentType}&dateStart=${this.dateStart}&dateEnd=${this.dateEnd}&search=${this.search}`;
      },
      deep: true,
    },
    taxpayer_id(value) {
      if (value !== null) {
        this.client_type = '';
      }
    },
  },
  async mounted() {
    this.headers = headersAll;
    this.queryParams = `&type=${this.documentType}&dateStart=${this.dateStart}&dateEnd=${this.dateEnd}&search=${this.search}`;
    await this.getProvincia().then((response) => {
      this.itemsProvince = response.data;
      this.cat_province_id = this.itemsProvince[0].code;
    });
    if (!this.can('descargar_json') && !this.can('descargar_xml') && !this.can('descargar_pdf')
        && !this.can('enviar_correo') && !this.can('historial_correo')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Acciones'), 1);
    }
  },
  methods: {
    updateQueryParams() {
      let search = this.search;
      search.replace('EMISOR', '');
      if (this.taxpayer_rif !== undefined && this.taxpayer_rif !== null) {
        search = `EMISOR: ${this.taxpayer_rif};${this.search}`;
      }

      this.queryParams = `&type=${this.documentType}&dateStart=
        ${this.dateStart}&dateEnd=${this.dateEnd}&search=${search}&state=${this.cat_province_id}&typeclient=${this.client_type}`;
    },
    openModalAyuda() {
      this.dialogAyuda = true;
    },
    getFecha() {
        const fecha = new Date();
        fecha.setDate(fecha.getDate() - 7);
        return fecha.toISOString().split('T')[0];
    },
    getLogo() {
      if (this.taxpayer_id !== null) {
        window.axios.get(`/api/enterprises/${this.taxpayer_id}/logo`)
        .then((result) => {
          this.logo = (result.data.Archivo) ? `data:image/png;base64, ${result.data.Archivo}`
            : 'https://cdn.vuetifyjs.com/images/parallax/material.jpg';
        });
      } else {
        this.logo = 'https://cdn.vuetifyjs.com/images/parallax/material.jpg';
      }
    },
    getProvincia() {
        const state = this.user.state != null ? this.user.state : 'Todos';
        const url = `/api/provinces/${state}`;
        return window.axios.get(url);
    },
    today(menu) {
      if (menu === 'one') {
        this.dateStart = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
        this.dateMenu1 = false;
      } else {
        this.dateEnd = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
        this.dateMenu2 = false;
      }
    },

  },
};
</script>
